import { render, staticRenderFns } from "./RoundChecklistItems.vue?vue&type=template&id=2a2f925d"
import script from "./RoundChecklistItems.vue?vue&type=script&lang=js"
export * from "./RoundChecklistItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports